import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Ingredient, IngredientsFilters } from '../../../commons/models/ingredient';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Store } from '@ngrx/store';


export type IngredientColumns = ["name", "description", "additionPrice", "minusPrice", "actions"];

@Component({
  selector: 'app-ingredients-list',
  templateUrl: './ingredients-list.component.html',
  styleUrls: ['./ingredients-list.component.scss']
})
export class IngredientsListComponent{
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  private store$ : Store;

  @Input()
  ingredients: Ingredient[];

  @Input()
  selectedIngredient: Ingredient[];

  @Input()
  defaultFilters: IngredientsFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: Ingredient | null;

  @Input()
  total: Observable<number>;

  @Input()
  displayedColumns: string[] = ["name", "description", "additionPrice", "minusPrice", "actions"];


  @Input() canAdd: boolean;
  @Input() canEdit: boolean;
  @Input() canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<IngredientsFilters> = new EventEmitter<IngredientsFilters>();

  @Output()
  onSelectIngredient: EventEmitter<Ingredient> = new EventEmitter<Ingredient>();
  @Output()
  onAddIngredient: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditIngredient: EventEmitter<Ingredient> = new EventEmitter<Ingredient>();
  @Output()
  onShowIngredient: EventEmitter<Ingredient> = new EventEmitter<Ingredient>();
  @Output()
  onAddSelectedIngredient: EventEmitter<Ingredient> = new EventEmitter<Ingredient>();
  @Output()
  onRemoveSelectedIngredient: EventEmitter<Ingredient> = new EventEmitter<Ingredient>();

  get selectedItems(): boolean {
    return this.selectedIngredient.length > 0;
  }

  ngAfterViewInit() {
    console.log("Paginator inizializzato:", this.paginator);
    console.log("Sort inizializzato:", this.sort);
  
    if (this.sort) {
      this.sort.sortChange.subscribe((sort) => {
        this.onSortChange.emit(sort);
      });
    } else {
      console.warn("Sort non inizializzato correttamente!");
    }
  
    if (this.paginator) {
      this.paginator.page.subscribe((pageEvent) => {
        this.onPageChange.emit(pageEvent);
      });
    } else {
      console.warn("Paginator non inizializzato correttamente!");
    }
  }
  
  // ngAfterViewInit() {
  //   console.log("Paginator inizializzato", this.paginator);
  //   this.sort.sortChange.subscribe((sort) => {
  //     this.onSortChange.emit(sort);
  //   });
  //   this.paginator.page.subscribe((pageEvent) => {
  //     this.onPageChange.emit(pageEvent);
  //   });
  // }
  
  
  isSelected(ingredient: Ingredient): boolean {
    return this.selectedIngredient.map(obj => obj.id).includes(ingredient.id)
  }
  
  addIngredient() {
    this.onAddIngredient.emit();
  }
  
  addSelectedIngredient(ingredient: Ingredient) {
    if(this.isSelectable(ingredient)) {
      this.onAddSelectedIngredient.emit(ingredient);
    }
  }
  
  isSelectable(ingredient: Ingredient): boolean {
    return !ingredient.id
  }

  toggleSelectedIngredient(ingredient: Ingredient) {
    if (this.isSelected(ingredient)) {
      this.removeSelectedIngredient(ingredient);
    } else {
      this.addSelectedIngredient(ingredient);
    }
  }
  
  editIngredient(ingredient: Ingredient) {
    this.onEditIngredient.emit(ingredient);
  }

  selectIngredient(ingredient: Ingredient) {
    this.onSelectIngredient.emit(ingredient);
  }

  removeSelectedIngredient(ingredient: Ingredient) {
    this.onRemoveSelectedIngredient.emit(ingredient)
  }

  onFilter(filters: IngredientsFilters) {
    // this.paginator.firstPage();
    // this.onFilterChange.emit(filters);
    if (this.paginator) {
      this.paginator.firstPage();
    } else {
      console.warn("Paginator non è ancora disponibile!");
    }
    this.onFilterChange.emit(filters);
  }
  
  showIngredient(activityList: Ingredient) {
      this.onShowIngredient.emit(activityList);
  }

  isAllSelected() {
    const numSelected = this.selectedIngredient.length;
    const numRows = this.ingredients.filter(bl => this.isSelectable(bl)).length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selectedIngredient.forEach(bl => this.removeSelectedIngredient(bl)) :
        this.ingredients.forEach(bl => this.addSelectedIngredient(bl));
  }

}
